import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../Sponsors';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import Whatsapp from '../../components/Whatsapp';
import { relative } from 'node:path';

const FooterLayout: React.FC = ({ children }) => {
  return (   <div style={{width: '100%', zIndex:100, position: 'relative', display: 'flex', justifyContent: 'center'}}> <Whatsapp number="5551981228775" text="Olá! Estou no Fórum Científico Hospital Unimed Erechim!" />
  </div>
  );
};

export default FooterLayout;
